import { CredentialEmailModel } from './credentialEmail.model';

export class CredentialEmailConfigurationModel {
  initialEmail: CredentialEmailModel;
  renewalEmails: CredentialEmailModel[];
  reinstatementEmails: CredentialEmailModel[];
  isRenewalAvailable: boolean;
  isReinstatementAvailable: boolean;
  earliestRenewalOffset?: number;
  latestRenewalOffset?: number;
  earliestReinstatementOffset?: number;

  public static parse(data: CredentialEmailConfigurationModel): CredentialEmailConfigurationModel {
    if (!data) return null;
    let config = new CredentialEmailConfigurationModel();
    config.initialEmail = data.initialEmail;
    config.renewalEmails = data.renewalEmails;
    config.reinstatementEmails = data.reinstatementEmails;
    config.isRenewalAvailable = data.isRenewalAvailable;
    config.isReinstatementAvailable = data.isReinstatementAvailable;
    config.earliestRenewalOffset = data.earliestRenewalOffset;
    config.latestRenewalOffset = data.latestRenewalOffset;
    config.earliestReinstatementOffset = data.earliestReinstatementOffset;
    return config;
  }
}
